export const TONE_OF_VOICE_OPTIONS = [
    {
        id: 'professional',
        label: 'Professional',
        description: 'Polished and trustworthy',
        icon: '💼',
    },
    {
        id: 'friendly',
        label: 'Friendly',
        description: 'Warm and approachable',
        icon: '😊',
    },
    {
        id: 'bold',
        label: 'Bold',
        description: 'Confident and energetic',
        icon: '⚡',
    },
    {
        id: 'casual',
        label: 'Casual',
        description: 'Relaxed and conversational',
        icon: '✌️',
    },
    {
        id: 'playful',
        label: 'Playful',
        description: 'Fun and witty',
        icon: '🎉',
    },
];
export const GENERAL_GOAL_OPTIONS = [
    { id: 'grow_audience', label: 'Grow my audience', icon: '📈' },
    { id: 'save_time', label: 'Save time on marketing', icon: '⏰' },
    { id: 'better_content', label: 'Create better content', icon: '✨' },
    { id: 'build_brand', label: 'Build my brand', icon: '🌟' },
    { id: 'increase_sales', label: 'Increase sales', icon: '💰' },
];
export const VALID_GOAL_IDS = new Set(GENERAL_GOAL_OPTIONS.map(g => g.id));
export const GENERAL_GOAL_IDS_PROMPT = GENERAL_GOAL_OPTIONS.map(g => g.id).join(', ');
//# sourceMappingURL=onboarding-step.const.js.map